"use server";

import { requireAdmin } from "@/lib/require-admin";
import { signOut } from "@/lib/auth";

export async function signOutAction() {
  await requireAdmin();

  await signOut({ redirectTo: "/admin/login" });
}
